
import React, { useMemo } from 'react';
import { Card, Segment } from 'tea-component';
import { getLocale } from 'umi';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { handleDownload } from '@/pages/dashboard/utils/utils';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import classNames from 'classnames';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLanguage } from '@home/utils/common';
import SvgIcon from '@home/components/SvgIcon';
import FunnelCard from '@/pages/dashboard/components/FunnelCard';
import { IFunnelCardContent } from '@/pages/dashboard/components/FunnelCard/types';

const formatterColumns = (list: any[], isEn: boolean) => {
  const columns = list?.map((item: any) => {
    const { nameEn, nameCn, key } = item || {};
    const name = getLanguage(isEn, nameEn, nameCn);
    return {
      ...item,
      dataKey: key,
      text: name,
      header: name,
    };
  });
  return columns || [];
};

const FunnelCardContent = (props: IFunnelCardContent) => {
  const {
    className,
    style,
    data,
    dataSource: propsDataSource,
    dataKey,
    filterVal,
    tabValue,
    setTabValue,
    tabOption: propsTabOption,
    columns: propsColumns,
    downloadColumns: propsDownloadColumns,
    bubbleColumns: propsBubbleColumns,
    showConfig,
    downloadTitleEn,
    downloadTitleCn,
    bubbleTitleEn,
    bubbleTitleCn,
    titleEn,
    titleCn,
    tipsEn,
    tipsCn,
    isOneColorLength = 10,
    bgColorList,
    isDataIndex = false, // 是否匹配数据下标,
    abnormalStyle = { height: '400px', background: '#fff' },
  } = props;
  const { data: propsData = [], loading, errorMsg: error } = data?.[dataKey] || {};
  const dataSource = propsDataSource || propsData;
  const { showTitle = true, showDesc = true, showTips = true, showTab = true, showDownload = true } = showConfig;
  const { rangeTime } = filterVal || {};
  const isEn = getLocale() === LANGUAGE_EN;

  const { isNoData, isOneColor, title, downloadTitle, tips } = useMemo(() => {
    // 无数据
    const isNoData = dataSource?.length === 0;
    // 是否使用一个色值背景条
    const isOneColor = dataSource?.length > isOneColorLength;
    // 标题
    const title = getLanguage(isEn, titleEn, titleCn);
    // 下载标题
    const downloadTitle = getLanguage(isEn, downloadTitleEn, downloadTitleCn) || title;
    // tips提示文本
    const tips = getLanguage(isEn, tipsEn, tipsCn);
    return { isNoData, isOneColor, title, downloadTitle, tips };
  }, [dataSource?.length, downloadTitleCn, downloadTitleEn, isEn, isOneColorLength, tipsCn, tipsEn, titleCn, titleEn]);

  const { tabOption, columns, bubbleColumns, downloadColumns } = useMemo(() => {
    // segment切换数据
    const tabOption = propsTabOption?.map((item: any) => {
      const { nameEn, nameCn } = item || {};
      return {
        ...item,
        text: getLanguage(isEn, nameEn, nameCn)
      };
    });
    // 漏斗配置
    const columns = formatterColumns(propsColumns, isEn);
    // 浮窗配置
    const bubbleColumns = formatterColumns(propsBubbleColumns, isEn);
    // 下载配置
    const downloadColumns = formatterColumns(propsDownloadColumns, isEn);
    return { tabOption, columns, bubbleColumns, downloadColumns };
  }, [isEn, propsBubbleColumns, propsColumns, propsDownloadColumns, propsTabOption]);

  // tab切换事件
  const tabChange = (value: string) => {
    setTabValue(value);
  };

  // 下载事件
  const handleDownloadFunc = () => {
    const tableOption = {
      data: dataSource,
      downloadData: dataSource,
      option: downloadColumns
    };
    handleDownload(tableOption, downloadTitle);
  };

  // segment切换
  const segmentDom = tabOption?.length > 0 && showTab ?
    <div className="dbd-funnel-filter">
      <Segment
        value={tabValue}
        onChange={(value: any) => tabChange(value)}
        options={tabOption}
      />
    </div> : null;

  return <Card className={classNames("dbd-funnel card-sort", className)} style={style}>
    <Card.Body
      title={<div className="dbd-funnel-title">
        {showTitle && <div className="dbd-funnel-text">{title}</div>}
        {showDesc && <div className="dbd-funnel-desc">({rangeTime?.[1]})</div>}
        {showTips && <TipContext className="dbd-funnel-icon" tipText={tips} />}
      </div>}
      operation={showDownload && !isNoData && !loading && !error ? (<div className="card-sort-flex">
        <i className="card-sort-char" onClick={handleDownloadFunc}>
          <SvgIcon type="download" className="card-sort-charicon" />
        </i>
      </div>) : null}
    >
      {/* tab切换dom元素 */}
      {segmentDom}
      <Abnormal
        style={abnormalStyle}
        component={<FunnelCard
          dataSource={dataSource}
          columns={columns}
          bubbleColumns={bubbleColumns}
          bubbleTitleEn={bubbleTitleEn}
          bubbleTitleCn={bubbleTitleCn}
          bgColorList={bgColorList}
          isOneColor={isOneColor}
          isDataIndex={isDataIndex}
        />}
        isLoading={loading}
        isError={error}
        isNoData={isNoData}
      />
    </Card.Body>
  </Card>;
};

export default FunnelCardContent;